<template>
  <v-icon :color="color">mdi-{{icon}}</v-icon>
</template>

<script>
  export default {
    name: "RecordingNetworkQuality",
    props:{
      quality : {
        required:true
      }
    },
    computed:{
      color(){
        switch (this.quality) {
          case 0:return 'error';
          case 1:return 'error';
          case 2:return 'error';
          case 3:return 'warning';
          case 4:return 'success';
          case 5:return 'success';
          default:return 'grey';
        }
      },
      icon(){
        switch (this.quality) {
          case 0:return 'signal-off';
          case 1:return 'signal-cellular-1';
          case 2:return 'network-strength-2';
          case 3:return 'signal-cellular-2';
          case 4:return 'signal-cellular-2';
          case 5:return 'signal-cellular-3';
          default:return 'grey';
        }
      }
    }
  }
</script>

<style scoped>

</style>